import { Link } from 'react-router-dom';
import { AmplifySignIn } from '@aws-amplify/ui-react';
import Logo from '../components/Logo';

type setStringStateType = (password: string) => void;
interface IProps {
  signInUsername: string;
  setUsername: setStringStateType;
  signInPassword: string;
  setPassword: setStringStateType;
}
type RetainValueProps = [Event, (event: Event) => string];

export default function SignIn({
  signInUsername,
  setUsername,
  signInPassword,
  setPassword,
}: IProps) {
  // Function definition for handleInputChange only allows one parameter.
  // However, two parameters exist. The second is a callback that must be called with the event.
  // Leveraging props, allows us to capture the callback with typescript.
  const getRetainValueFunction =
    (setValue: setStringStateType) =>
    (...props: any[]) => {
      const [event, runOriginalHandler] = props as unknown as RetainValueProps;
      const value = runOriginalHandler(event);
      setValue(value);
    };

  const retainUsername = getRetainValueFunction(setUsername);
  const retainPassword = getRetainValueFunction(setPassword);

  return (
    <div slot="sign-in" className="flex flex-col items-center">
      <Link to="/">
        <Logo className="w-40 mb-8 -mt-4" />
      </Link>
      <AmplifySignIn
        headerText="Sign in to your Account"
        usernameAlias="email"
        formFields={[
          {
            type: 'email',
            label: 'Email',
            placeholder: 'Email Address',
            required: true,
            value: signInUsername,
            handleInputChange: retainUsername,
          },
          {
            type: 'password',
            label: 'Password',
            placeholder: '••••••••',
            required: true,
            value: signInPassword,
            handleInputChange: retainPassword,
          },
        ]}
      />
    </div>
  );
}
